import { render } from "./MTextInput.vue?vue&type=template&id=65c060a7"
import script from "./MTextInput.vue?vue&type=script&lang=js"
export * from "./MTextInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__